"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6086],{

/***/ 8172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RSSButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9642);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6008);



function RSSButton(param) {
    var link = param.link;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "fixed bottom-[66px] right-24 z-[997] flex h-14 w-14 cursor-pointer flex-row items-center justify-center rounded-[56px] bg-[#f37d00] text-center no-underline shadow-[0_2px_2px_0_rgba(0,0,0,.14),_0_3px_1px_-2px_rgba(0,0,0,.12)] transition-all duration-300 ease-ease hover:bg-mglGray800 phone:bottom-6",
        href: link,
        style: {
            color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_1__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex items-center justify-center text-2xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                icon: "mdi:rss",
                width: 24,
                height: 24
            })
        })
    });
}


/***/ })

}]);